import React from "react"
import cls from "classnames"
import * as styles from "./index.module.scss"
import FreeTryOut from "@/components/home/free-try-out"
import Container from "@/components/container"
import { ADVANTAGE_NODES, ADVANTAGE_SECTION } from "@/constants/home"
import CaseList from "@/components/home/case-list"

const AdvantageNodes: AdvantageNode[] = ADVANTAGE_NODES

const Advantage: React.FC = () => {
  const renderLayout = (nodes: AdvantageNode[]) => {
    const reactNode = []
    for (let i = 0; i < nodes.length; i++) {
      const left: AdvantageNode = nodes[i++]
      const right: AdvantageNode = nodes[i]
      reactNode.push(
        <div className="columns" key={i}>
          {renderNode(left)}
          {renderNode(right)}
        </div>
      )
    }
    return reactNode
  }

  const renderNode = (node: AdvantageNode) => {
    return (
      <div className={cls("column px-4", styles.node)} key={node.id}>
        <div className={cls("media is-align-items-center", styles.mediaStyle)}>
          <div className="media-left is-align-self-center">
            <figure className={styles.image}>
              <img src={node.image} alt={node.alt} />
            </figure>
          </div>
          <div className="media-content">
            <h3 className="has-text-left">{node.title}</h3>
            <p className="content has-text-left">{node.desc}</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <section
      className={cls(
        "is-flex is-flex-direction-column is-align-items-center",
        styles.advantage
      )}
    >
      <div className={styles.title}>
        <h4>{ADVANTAGE_SECTION.h4}</h4>
        <h1>{ADVANTAGE_SECTION.h1}</h1>
      </div>
      <Container>{renderLayout(AdvantageNodes)}</Container>
      <FreeTryOut />
      <CaseList />
    </section>
  )
}

export default Advantage
